(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("scrollableNavBar", {
            templateUrl: "app/components/scrollable-nav-bar/scrollable-nav-bar.html",
            controller: ScrollableNavBarController,
            bindings: {
                items: '<',
                trackBy: '@',
                label: '@',
                divider: '<',
                transparentButtons: '<',
                disableFirstSelect: '<',
                isToggle: '<',
                iconLeftClass: '<',
                iconRightClass: '<',
                selectedItemId: '=',
                scrollThreshold: '<',
                navItemTemplate: '<'
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function ScrollableNavBarController($scope, $element, $timeout, $window) {
        var vm = this;
        var componentDomElement = $element[0];

        var defaultTrackBy = 'id';
        var defaultTransparentButtons = false;
        var defaultDisableFirstSelect = false;
        var defaultIsToggle = false;
        var defaultIconLeft = 'fa-chevron-left';
        var defaultIconRight = 'fa-chevron-right';
        var defaultScrollThreshold = 0.8;
        var defaultNavItemTemplate = 'app/components/scrollable-nav-bar/nav-item/default-template.html';
        var scrollByPixels = undefined;

        vm.$onInit = init;
        vm.$postLink = postRender;
        vm.$onDestroy = onDestroy;
        vm.selectItem = selectItem;
        vm.scrollLeft = scrollLeft;
        vm.scrollRight = scrollRight;

        vm.isMobile = detectar_mobile();
        vm.resizeObserver = undefined;
        vm.disableScrollLeft = false;
        vm.disableScrollRight = false;
        vm.showScrollButtons = false;

        function init() {
            vm.trackBy = vm.trackBy !== undefined ? vm.trackBy : vm.label !== undefined ? vm.label : defaultTrackBy;
            vm.transparentButtons = vm.transparentButtons !== undefined ? vm.transparentButtons : defaultTransparentButtons;
            vm.disableFirstSelect = vm.disableFirstSelect !== undefined ? vm.disableFirstSelect : defaultDisableFirstSelect;
            vm.isToggle = vm.isToggle !== undefined ? vm.isToggle : defaultIsToggle;
            vm.iconLeftClass = vm.iconLeftClass ? vm.iconLeftClass : defaultIconLeft;
            vm.iconRightClass = vm.iconRightClass ? vm.iconRightClass : defaultIconRight;
            vm.scrollThreshold = vm.scrollThreshold ? vm.scrollThreshold : defaultScrollThreshold;
            vm.navItemTemplate = vm.navItemTemplate ? vm.navItemTemplate : defaultNavItemTemplate;
        }

        function postRender() {
            waitForElement('.nav-bar', componentDomElement)
                .then(function (navBarElement) {
                    vm.navBarElement = navBarElement;
                    updateScrollParams();
                    vm.resizeObserver = new ResizeObserver(function () {
                        updateScrollParams();
                    });
                    vm.resizeObserver.observe(vm.navBarElement);

                    if (!vm.disableFirstSelect) {
                        selectItem(vm.items && vm.items.length > 0 ? vm.items[0] : undefined);
                    }
                });

            function updateScrollParams() {
                vm.showScrollButtons = vm.navBarElement.clientWidth !== vm.navBarElement.scrollWidth;
                scrollByPixels = vm.navBarElement.offsetWidth * vm.scrollThreshold;
            }
        }

        function onDestroy() {
            if (vm.resizeObserver) {
                vm.resizeObserver.disconnect();
            }
        }

        function selectItem(item) {
            if (item) {
                if (vm.isToggle && vm.selectedItemId === item[vm.trackBy]) {
                    // Delay to avoid conflict with md-nav-bar internal state
                    $timeout(function () {
                        vm.selectedItemId = null;
                    }, 0);
                } else {
                    vm.selectedItemId = item[vm.trackBy];
                    centerOnItem(item);
                }
            }
        }

        function centerOnItem(item) {
            var itemSelector = 'scrollable-nav-bar [id="' + item[vm.trackBy] + '"]';
            var element = document.querySelector(itemSelector);

            var leftDistance = getDistanceFromParentLeft(element, vm.navBarElement);
            var halfElementWidth = Math.ceil(element.clientWidth / 2);
            var halfParentWidth = Math.ceil(vm.navBarElement.clientWidth / 2);
            var distanceToCenter = halfParentWidth - halfElementWidth - leftDistance;
            vm.navBarElement.scrollBy({left: -distanceToCenter, behavior: 'smooth'});

            function getDistanceFromParentLeft(child, scrollParent) {
                const childRect = child.getBoundingClientRect();
                const parentRect = scrollParent.getBoundingClientRect();
                return childRect.left - parentRect.left;
            }
        }

        function scrollLeft() {
            vm.navBarElement.scrollBy({ left: -scrollByPixels, behavior: 'smooth' });
        }

        function scrollRight() {
            vm.navBarElement.scrollBy({ left: scrollByPixels, behavior: 'smooth' });
        }
    }
})();
